export default __webpack_public_path__ + "static/media/1691.75d97519.png";